// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var sectionContainer = "ImageSection-module--sectionContainer--39xn2";
export var noPaddingTop = "ImageSection-module--noPaddingTop--1jwAD";
export var section = "ImageSection-module--section--3MapW";
export var introText = "ImageSection-module--introText--UCHJ8";
export var outroText = "ImageSection-module--outroText--2v6UY";
export var desktopImageContainer = "ImageSection-module--desktopImageContainer--3W5AY";
export var noMobileImage = "ImageSection-module--noMobileImage--1qrzH";
export var backgroundWatermarkContainer = "ImageSection-module--backgroundWatermarkContainer--1NqYL";
export var mobileImage = "ImageSection-module--mobileImage--IM_h0";
export var introSmallDescription = "ImageSection-module--introSmallDescription--3Er5n";
export var smallDescription = "ImageSection-module--smallDescription--LfZI-";